import { UserDTO } from '@api/user/dtos/UserDTO';
import Role from '@constants/role';

export function isAdmin(user: UserDTO): boolean {
  return user && user.authorities && user.authorities.includes(Role.ADMINISTRATOR.toString());
}

export function isContractor(user: UserDTO): boolean {
  return (
    user &&
    user.authorities &&
    user.authorities.some(value =>
      [
        Role.APAVE_CONTRACTOR_LIFTING.toString(),
        Role.DEKRA_CONTRACTOR_LIFTING.toString(),
        Role.VERITAS_CONTRACTOR_LIFTING.toString(),
        Role.DEKRA_CONTRACTOR_ELECTRICAL.toString(),
        Role.VERITAS_CONTRACTOR_ELECTRICAL.toString(),
        Role.APAVE_CONTRACTOR_ELECTRICAL.toString(),
        Role.EN_EL_INSPECTOR_ELECTRICAL.toString(),
        Role.SY_CONTRACTOR_ELECTRICAL.toString()
      ].includes(value)
    )
  );
}

export function isInspector(user: UserDTO): boolean {
  return (
    user &&
    user.authorities &&
    user.authorities.some(value =>
      [
        Role.INSPECTOR_LIFTING.toString(),
        Role.INSPECTOR_MANAGER_LIFTING.toString(),
        Role.INSPECTOR_ELECTRICAL.toString(),
        Role.INSPECTOR_MANAGER_ELECTRICAL.toString(),
        Role.SY_INSPECTOR_ELECTRICAL.toString()
      ].includes(value)
    )
  );
}

export function hasPermissionsDeleteUpload(user: UserDTO, uploadCompany: string): boolean {
  return isContractor(user) && user.companies?.includes(uploadCompany);
}
